import { render } from "./PaymentList.vue?vue&type=template&id=28b24e4c&ts=true"
import script from "./PaymentList.vue?vue&type=script&lang=ts"
export * from "./PaymentList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__